module.exports = ".text-green {\n    color: #269da1;\n}\n"